import Vue from 'vue';
import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faClone,
    faColumns,
    faCopy,
    faDoorClosed,
    faEdit,
    faEllipsisV,
    faFileImport,
    faMinus,
    faPlus,
    faTrash,
    faRecycle,
    faSave,
    faCheck,
    faSearch,
    faExclamation,
    faFileExport,
    faWind,
    faTemperatureHigh,
    faTemperatureLow,
    faPlusSquare,
    faPenSquare,
    faSync,
    faHistory,
    faTimes,
    faTimesCircle,
    faComment,
    faComments,
    faClipboardList,
    faQuestion,
    faUsers,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faUserTie,
    faUser,
    faFileUpload,
    faFilePdf,
    faFileAlt,
    faFileCsv,
    faFileExcel,
    faInfo,
    faPen,
    faDownload,
    faLock,
    faUnlock
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faClone,
    faColumns,
    faCopy,
    faDoorClosed,
    faEdit,
    faEllipsisV,
    faFileImport,
    faMinus,
    faPlus,
    faTrash,
    faRecycle,
    faSave,
    faCheck,
    faSearch,
    faExclamation,
    faFileExport,
    faWind,
    faTemperatureHigh,
    faTemperatureLow,
    faPlusSquare,
    faPenSquare,
    faSync,
    faHistory,
    faTimes,
    faTimesCircle,
    faComment,
    faComments,
    faClipboardList,
    faQuestion,
    faUsers,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faUserTie,
    faUser,
    faFileUpload,
    faFilePdf,
    faFileAlt,
    faFileCsv,
    faFileExcel,
    faInfo,
    faPen,
    faDownload,
    faLock,
    faUnlock
);
Vue.component('fa', FontAwesomeIcon);
